import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material'
import { useSnackbar } from 'notistack'
import { useDeleteSalesCommission } from '../../api/sales-commission'

const Delete = ({ openDelete, data, onClose, refetch }) => {
  const { mutateAsync, isLoading } = useDeleteSalesCommission()
  const { enqueueSnackbar } = useSnackbar()

  const handleDeleteAnnouncement = async () => {
    try {
      await mutateAsync({ id: data._id })
      refetch()
      enqueueSnackbar('Successfully removed.', { variant: 'success' })
      onClose()
    } catch (e) {
      const errorData = e?.response?.data?.errors || []
      const message =
        errorData.length > 0 ? errorData[0]?.msg : 'Something went wrong. Please try again.'
      enqueueSnackbar(message, { variant: 'error' })
    }
  }

  return (
    <Dialog maxWidth='sm' open={openDelete}>
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent dividers>
        <Typography>
          Are you sure you want to remove commission for{' '}
          <b>
            {data.salesId} {data.htgCompany} ({data.monthYear})
          </b>
          ? This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          variant='contained'
          style={{ background: 'red' }}
          onClick={handleDeleteAnnouncement}
          disabled={isLoading}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default Delete
